import React from 'react';
import colours from 'styles/colours';
import AppItem from './AppItem';

const containerStyles = {
    flex: 1,
    overflowY: 'auto',
    background: colours.background.panel,
    paddingTop: 8,
};

const listStyles = {
    background: colours.background.listRow.normal,
    borderTop: `1px solid ${colours.border.rowDivider}`,
    borderBottom: `1px solid ${colours.border.rowDivider}`,
};

const emptyStyles = {
    padding: '16px 20px',
    fontSize: 13,
    color: colours.font.bodyMuted,
    margin: 0,
    fontStyle: 'italic',
};

export default function AppList({apps, onClose}) {
    return (
        <div style={containerStyles}>
            {apps && apps.length > 0
                ? (
                    <div style={listStyles}>
                        {apps.map(app => <AppItem key={app.id} app={app} onClose={onClose}/>)}
                    </div>
                )
                : <p style={emptyStyles}>No applications available.</p>
            }
        </div>
    );
}

